module.exports = __webpack_public_path__ + "img/cur11.6034dcc0.png";